<!-- src/app/views/prueba-testimonial/listado-prueba-testimonial/listado-prueba-testimonial.component.html -->
<mat-card appearance="outlined" *appRoles="['PruebasTestimonial.Listar']">
  <mat-card-header [hidden]="!showHeader">
    <div class="header-nombre-nuevo">
      <h2>Pruebas Testimoniales</h2>
      <app-button-new (click)="openDialog({ accion: accionesDialog.Agregar})"></app-button-new>
    </div>
  </mat-card-header>

  <!-- Contenido de filtros -->
  <!-- <mat-card-content>
    <form [formGroup]="formFilter">
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Descripción</mat-label>
            <input matInput type="text" formControlName="Descripcion" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Persona Testigo</mat-label>
            <input matInput type="text" formControlName="PersonaTestigo" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Estado de Prueba</mat-label>
            <input matInput type="text" formControlName="EstadoPrueba" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Medio de Registro</mat-label>
            <input matInput type="text" formControlName="MedioRegistro" />
          </mat-form-field>
        </div>
      </div>

      <div class="row" *ngIf="checkedFiltroAvanzado">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Grupo</mat-label>
            <input matInput type="number" formControlName="Grupo" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Autoridad Declaración</mat-label>
            <input matInput type="text" formControlName="AutoridadDeclaracion" />
          </mat-form-field>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango de Fechas Declaración</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate placeholder="Fecha Desde" [formControl]="formFilter.get('FechaDeclaracionDesde')">
              <input matEndDate placeholder="Fecha Hasta" [formControl]="formFilter.get('FechaDeclaracionHasta')">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-auto">
          <div style="display: flex; align-items: center; gap: 8px;">
            <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
            <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>
          </div>
        </div>
        <div class="col-auto">
          <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
            Filtros Avanzados
          </mat-slide-toggle>
        </div>
      </div>
    </form>
  </mat-card-content> -->

  <mat-card-content>
    <mat-divider></mat-divider>
    <ngx-spinner [zIndex]="100" name="spPruebasTestimoniales" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>

    <!-- Inicio Contenedor acciones tabla -->
    <div class="contenedor-acciones-tablas">
      <div class="acciones-tabla">
        <!-- Botón de Acciones -->
      </div>
      <app-input-filter-table (filterChange)="applyFilter($event)" *ngIf="data">
      </app-input-filter-table>
    </div>
    <!-- Fin Contenedor acciones tabla -->

    <div *ngIf="data">
      <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" matSort matSortStart="asc">

        <ng-container matColumnDef="grupo">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Grupo</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pruebaTestimonial">
            <span *ngIf="pruebaTestimonial.grupo; else sinGrupo">
              Grupo {{ pruebaTestimonial.grupo }}
            </span>
            <ng-template #sinGrupo>
              <span class="text-muted">Sin grupo</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="descripcion">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Descripción</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pruebaTestimonial">
            <div>
              <strong>{{ pruebaTestimonial.descripcion | titlecase }}</strong>
              <div class="text-muted small" *ngIf="pruebaTestimonial.observaciones">
                {{ pruebaTestimonial.observaciones }}
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="personaTestigo">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Persona Testigo</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pruebaTestimonial">
            <span *ngIf="pruebaTestimonial.personaTestigo; else sinTestigo">
              {{ pruebaTestimonial.personaTestigo.nombreCompleto | titlecase }}
            </span>
            <ng-template #sinTestigo>
              <span class="text-muted">Sin testigo</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estadoPrueba">
          <mat-header-cell *matHeaderCellDef>
            <strong>Estado</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pruebaTestimonial">
            {{pruebaTestimonial.pruebaInformativa?.descripcion | titlecase}}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fechaDeclaraion">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Fecha Declaración</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pruebaTestimonial">
            <span *ngIf="pruebaTestimonial.fechaDeclaraion; else sinFecha">
              {{ pruebaTestimonial.fechaDeclaraion | date:'dd/MM/yyyy' }}
            </span>
            <ng-template #sinFecha>
              <span class="text-muted">Sin fecha</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="medioRegistro">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Medio</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pruebaTestimonial">
            <span *ngIf="pruebaTestimonial.medioRegistro; else sinMedio">
              {{ pruebaTestimonial.medioRegistro | titlecase }}
            </span>
            <ng-template #sinMedio>
              <span class="text-muted">Sin especificar</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <!-- Accion Column -->
        <ng-container matColumnDef="accion">
          <mat-header-cell *matHeaderCellDef>
            <strong>Acción</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pruebaTestimonial" class="action-link">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Menú de acciones">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Ver, entidad: pruebaTestimonial })"
                *appRoles="['PruebasTestimonial.Ver']">
                <mat-icon>visibility</mat-icon>
                <span>Ver</span>
              </button>
              <button mat-menu-item
                (click)="openDialog({ accion: accionesDialog.Modificar, entidad: pruebaTestimonial })"
                *appRoles="['PruebasTestimonial.Modificar']">
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </button>
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Eliminar, entidad: pruebaTestimonial })"
                *appRoles="['PruebasTestimonial.Eliminar']">
                <mat-icon>delete</mat-icon>
                <span>Eliminar</span>
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row matRipple *matRowDef="let row; columns: displayedColumns"></mat-row>
      </table>

      <mat-paginator showFirstLastButtons class="paginator" *ngIf="data" [pageSize]="20"
        [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
      </mat-paginator>
    </div>
    <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>
  </mat-card-content>
</mat-card>
